import { createRouter, createWebHistory } from "vue-router";
import { auth } from "@/firebase"; // Firebase auth'u import ediyoruz
import HomePage from "../views/HomePage.vue";
import PetListingPage from "../views/PetListingPage.vue";
import PetListingHomePage from "../views/PetListingHomePage.vue";
import ServiceListingPage from "../views/ServiceListingPage.vue";
import UserSignup from "../views/UserSignup.vue";
import UserLogin from "../views/UserLogin.vue";
import AddListing from "../views/AddListing.vue"; // İlan verme sayfasını ekleyin
import EditPetListing from "../views/EditPetListing.vue"; // İlan düzenleme sayfası
import ProfilePage from "@/views/ProfilePage.vue";
import PetDetails from "@/views/PetDetails.vue"; // Yeni sayfayı ekleyin
import MapView from "@/views/MapView.vue";
import ChatPage from "@/views/ChatPage.vue";
import ServiceDetails from "@/views/ServiceDetails.vue";
import ShopListing from "@/views/ShopListing.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      title: "Home Page",
    },
  },
  {
    path: "/services",
    name: "services",
    component: ServiceListingPage,
    meta: {
      title: "Services",
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: UserSignup,
    meta: {
      title: "Sign Up",
    },
  },
  {
    path: "/login",
    name: "login",
    component: UserLogin,
    meta: {
      title: "Log In",
    },
  },
  {
    path: "/add-listing",
    name: "add-listing",
    component: AddListing,
    meta: {
      title: "Add Listing",
    },
  },
  {
    path: "/edit-listing/:id",
    name: "edit-listing",
    component: EditPetListing,
    meta: {
      title: "Edit Listing",
      requiresAuth: true,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfilePage,
    meta: {
      title: "Profile",
      requiresAuth: true,
    },
  },
  {
    path: "/service-details/:id", // Servis detay sayfası için dinamik route
    name: "service-details",
    component: ServiceDetails,
    meta: {
      title: "Service Details",
    },
  },
  {
    path: "/pets/:id", // Pet detay sayfası için dinamik route
    name: "pet-details",
    component: PetDetails,
    meta: {
      title: "Pet Details",
    },
  },
  {
    path: "/petmapview",
    name: "MapView",
    component: MapView,
    meta: {
      title: "Pet Map View",
    },
  },
  {
    path: "/petshome",
    name: "petshome",
    component: PetListingHomePage,
    meta: {
      title: "Pets Home Page",
    },
  },
  {
    path: "/pets",
    name: "pets",
    component: PetListingPage,
    meta: {
      title: "Pets Listing Page",
    },
  },
  
  {
    path: "/chat",
    name: "chat",
    component: ChatPage,
    meta: {
      title: "Chat",
      requiresAuth: true,
    },
  },
  {
    path: "/shop",
    name: "shop",
    component: ShopListing,
    meta: {
      title: "Shop",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  // Meta title varsa kullan, yoksa varsayılan title'ı kullan
  document.title = to.meta.title ? `${to.meta.title} | PetQueen` : "PetQueen";
});

// Auth state değişikliklerini dinle
auth.onAuthStateChanged((user) => {
  const currentRoute = router.currentRoute.value;
  if (!user && currentRoute.meta.requiresAuth) {
    router.push("/");
  }
});

// Navigation guard güncellemesi
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  // Auth durumunu bekle
  const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        unsubscribe();
        resolve(user);
      }, reject);
    });
  };

  const currentUser = await getCurrentUser();

  if (requiresAuth && !currentUser) {
    // Geri dönüş URL'sini query parametresi olarak ekle
    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
});

export default router;
